import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { cn } from '@/shared/lib/cn';

/**
 * Общая рамка экранов входа и регистрации: слева фирменная панель на
 * градиенте карточки (--card-gradient), справа форма. На мобильном панель
 * схлопывается в шапку.
 */
export function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-[var(--background)] lg:grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]">
      <BrandPanel />

      <main className="flex min-h-[60vh] items-center justify-center px-5 py-10 lg:min-h-screen lg:px-10">
        <div className="w-full max-w-[420px]">
          <header className="mb-7">
            <h1 className="text-[26px] leading-tight font-semibold text-[var(--foreground)]">
              {title}
            </h1>
            <p className="mt-2 text-sm text-slate-500">{subtitle}</p>
          </header>

          {children}

          {footer ? (
            <div className="mt-7 text-center text-sm text-slate-500">
              {footer}
            </div>
          ) : null}
        </div>
      </main>
    </div>
  );
}

function BrandPanel() {
  return (
    <aside
      className={cn(
        'relative overflow-hidden bg-[image:var(--card-gradient)] px-6 py-10',
        'lg:flex lg:flex-col lg:justify-between lg:px-12 lg:py-14'
      )}
    >
      {/* Мягкая засветка в углу — тот же приём, что на карточках проектов. */}
      <span
        aria-hidden
        className="pointer-events-none absolute -top-24 -right-24 h-72 w-72 rounded-full bg-white/10 blur-3xl"
      />
      <span
        aria-hidden
        className="pointer-events-none absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-white/5 blur-3xl"
      />

      <div className="relative">
        <Link
          to="/login"
          className="text-lg font-semibold tracking-tight text-white"
        >
          DOIT
        </Link>
        <p className="mt-1 text-xs tracking-[0.18em] text-white/50 uppercase">
          Модуль задач
        </p>
      </div>

      <div className="relative mt-8 hidden lg:block">
        <p className="max-w-[26ch] text-[30px] leading-[1.2] font-semibold text-white">
          Задачи, проекты и команда в одном месте
        </p>
      </div>

      <p className="relative mt-6 hidden text-xs text-white/40 lg:block">
        © {new Date().getFullYear()} DOIT
      </p>
    </aside>
  );
}
